import { FC } from "react";
import {
    Flex,
    Text,
    Heading,
    Icon,
    Collapse,
    useDisclosure,
} from "@smile2impress/components/relaunch";
import {
    Button,
    PlusCircledIcon,
    MinusCircledIcon,
} from "@smile2impress/components";

import getIcon from "utils/getIcon";

import { QuestionContent } from "./Question.types";
export const Question: FC<QuestionContent> = ({
    question,
    answer,
    icon,
    large = false,
}) => {
    const { isOpen, onToggle } = useDisclosure();

    return (
        <Flex
            direction={"column"}
            py={[1, 1, 2]}
            cursor="pointer"
            _first={{ pt: 0 }}
            onClick={onToggle}
        >
            <Flex
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Flex direction="row">
                    {icon && (
                        <Icon
                            w={[3]}
                            h={[3]}
                            as={getIcon(icon)}
                            mr={[1]}
                            alignSelf={large ? "center" : "flex-start"}
                        />
                    )}
                    <Heading
                        textStyle={large ? "H3" : "body"}
                        textTransform={large ? "uppercase" : "none"}
                        fontWeight={large ? "medium" : "bold"}
                        color="text.base"
                        alignSelf={large ? "center" : "flex-start"}
                        as="h3"
                    >
                        {question}
                    </Heading>
                </Flex>
                <Flex>
                    <Button
                        w={["24px", "24px", "32px"]}
                        h={["24px", "24px", "32px"]}
                        variant={"ghost"}
                        p={0}
                        ml={2}
                    >
                        <Icon
                            as={isOpen ? MinusCircledIcon : PlusCircledIcon}
                            w={["24px", "24px", "32px"]}
                            h={["24px", "24px", "32px"]}
                            color="text.base"
                        />
                    </Button>
                </Flex>
            </Flex>
            <Flex direction="column">
                <Collapse in={isOpen} animateOpacity>
                    <Text
                        textStyle={["body"]}
                        color="text.base"
                        pt={2}
                        pr={[3]}
                    >
                        {answer}
                    </Text>
                </Collapse>
            </Flex>
        </Flex>
    );
};
